var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPrescribedtests(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.999,
    height: 36,
    viewBox: "0 0 35.999 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping-list",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M32.848,0H3.151A2.932,2.932,0,0,0,0,2.638V33.362A2.932,2.932,0,0,0,3.151,36h29.7A2.932,2.932,0,0,0,36,33.362V2.638A2.932,2.932,0,0,0,32.848,0Zm.632,33.362a.588.588,0,0,1-.632.529H3.151a.588.588,0,0,1-.632-.529V2.638a.588.588,0,0,1,.632-.529h29.7a.588.588,0,0,1,.632.529Zm0,0",
    fill: "#f6781b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M74.122,80.631a1.028,1.028,0,0,0-1.266.167L71.2,82.7l-.259-.27a1.033,1.033,0,0,0-1.275-.118.676.676,0,0,0-.141,1.064l1,1.044a.983.983,0,0,0,.708.284h.021a.97.97,0,0,0,.712-.312l2.356-2.705a.679.679,0,0,0-.2-1.057Zm0,0",
    transform: "translate(-62.496 -74.285)",
    fill: "#0060a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M74.106,178.777a.9.9,0,0,0-1.262.2l-1.652,2.273-.258-.322a.9.9,0,1,0-1.411,1.129l1,1.248a.9.9,0,0,0,.706.339h.021a.9.9,0,0,0,.71-.372l2.348-3.231A.9.9,0,0,0,74.106,178.777Zm0,0",
    transform: "translate(-63.503 -165.273)",
    fill: "#0060a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M74.106,276.891a.9.9,0,0,0-1.262.2l-1.652,2.273-.258-.322a.9.9,0,1,0-1.411,1.129l1,1.248a.9.9,0,0,0,.706.339h.021a.9.9,0,0,0,.71-.372l2.348-3.231A.9.9,0,0,0,74.106,276.891Zm0,0",
    transform: "translate(-63.503 -256.207)",
    fill: "#0060a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M197.871,102.781H186.414a1.057,1.057,0,1,0,0,2.109h11.457a1.057,1.057,0,1,0,0-2.109Zm0,0",
    transform: "translate(-169.728 -95.554)",
    fill: "#f6781b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M197.871,204.941H186.414a1.057,1.057,0,1,0,0,2.109h11.457a1.057,1.057,0,1,0,0-2.109Zm0,0",
    transform: "translate(-169.728 -190.531)",
    fill: "#f6781b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M197.871,307.105H186.414a1.057,1.057,0,1,0,0,2.109h11.457a1.057,1.057,0,1,0,0-2.109Zm0,0",
    transform: "translate(-169.728 -285.512)",
    fill: "#f6781b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M74.106,375.008a.9.9,0,0,0-1.262.2l-1.652,2.273-.258-.322a.9.9,0,0,0-1.411,1.129l1,1.248a.9.9,0,0,0,.706.339h.021a.9.9,0,0,0,.71-.372l2.348-3.232A.9.9,0,0,0,74.106,375.008Zm0,0",
    transform: "translate(-63.503 -347.425)",
    fill: "#0060a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M197.871,409.266H186.414a1.057,1.057,0,1,0,0,2.109h11.457a1.057,1.057,0,1,0,0-2.109Zm0,0",
    transform: "translate(-169.728 -380.49)",
    fill: "#f6781b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrescribedtests);
export default __webpack_public_path__ + "static/media/icon_prescribedtests.39b41e53e87b6b6ac14e366186e9478f.svg";
export { ForwardRef as ReactComponent };